'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.controller_device_create', {
    url: '/company/:company_id/controller_create',
    template: '<controller-device-create></controller-device-create>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/controller_create/controller_create.routes.js